import type { FC } from 'react';
import type { Props as JoyrideProps } from 'react-joyride';
import Joyride from 'react-joyride';
import { useTheme } from 'styled-components/macro';

import Tooltip from './components/Tooltip';
import { getCustomStyles } from './OnboardingTour.styled';

type OnboardingTourPropsT = JoyrideProps;

const OnboardingTour: FC<OnboardingTourPropsT> = props => {
  const theme = useTheme();

  return <Joyride tooltipComponent={Tooltip} styles={getCustomStyles(theme)} {...props} />;
};

export default OnboardingTour;
